import { TextInput, Text } from "@mantine/core";
import { ReactNode } from "react";

import { useStyles } from "./styles";
import Flex from "components/Flex";
import { themeConfigAtom } from "atoms/clientConfig";
import { useAtomValue } from "jotai";
import { LockIcon } from "components/Icons/LockIcon";
import { useClientTranslation } from "hooks/useClientTranslation";
import { commonStyles } from "components/common/styles";

export type IbanProps =  {
  onChange: (value: string) => void
  label?: ReactNode;
  description?: ReactNode;
  placeholder?: string;
  name: string;
  value?: string;
  isValid: boolean;
};

export const IbanInput = ({
  onChange,
  name,
  label,
  description,
  value,
  placeholder,
  isValid,
}: IbanProps) => {
  const { t } = useClientTranslation();

  const classes = {...commonStyles().classes, ...useStyles().classes};
  const { colours } = useAtomValue(themeConfigAtom);
  return (
    <Flex gap={16}>
      <Flex gap={4}>
        <TextInput
          name={name}
          placeholder={placeholder}
          description={description}
          label={label}
          size="xl"
          value={value}
          onChange={e => onChange ? onChange(e.currentTarget.value) : null}
          classNames={{ input: (isValid ? classes.input : classes.inputErr) }}
        />
      </Flex>
      <Flex direction="row">
        <Flex gap= {8}>
          <LockIcon color={colours.primary}></LockIcon>
        </Flex>
        <Flex align="top" classNames={{root: classes.securityText}}>
          <Text classNames={{root: classes.securityText}}>{t('speedy_payment.iban_secure_notice')}</Text>
        </Flex>
      </Flex>
  </Flex>
    
  );
};
